import React from "react";
import ReactAudioPlayer from "react-audio-player";
import AudioFile from "../../assets/3i.mp3";
import Radio from "../../assets/radio.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      
    },
  ];
  return (
    <section id="testmonials">
      <h2>Why I choose Engineering 🎓?</h2>
      <Swiper
        className="container testimonials__container"
        spaceBetween={40}
        slidesPerView={1}
      >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial">
            <div className="client__avatar">
                <img src={Radio} alt="" />
            </div>
            <ReactAudioPlayer src={AudioFile} controls />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
